function renderMediaFieldChangeHandlerTemplate({
  indent,
  defaultValueFromHandler
}: {
  indent: string
  defaultValueFromHandler: string
}): string {
  return `(value) => {
${indent}            ${defaultValueFromHandler}(value)
${indent}            formField.onChange(value)
${indent}          }`
}

function renderMediaFieldFormFieldTemplate({
  indent,
  fieldName,
  formItemProps,
  labelWithDescription,
  onChange,
  acceptProp
}: {
  indent: string
  fieldName: string
  formItemProps: string
  labelWithDescription: string
  onChange: string
  acceptProp: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${formItemProps}>
${indent}      ${labelWithDescription}
${indent}      <FormControl>
${indent}        <MediaField
${indent}          value={formField.value}
${indent}          onChange={${onChange}}
${indent}          onBlur={formField.onBlur}
${indent}          disabled={isPending}${acceptProp}
${indent}        />
${indent}      </FormControl>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}

export function renderMediaFieldRenderer(
  request:
    | {
        kind: 'renderMediaFieldChangeHandlerTemplate'
        props: {
          indent: string
          defaultValueFromHandler: string
        }
      }
    | {
        kind: 'renderMediaFieldFormFieldTemplate'
        props: {
          indent: string
          fieldName: string
          formItemProps: string
          labelWithDescription: string
          onChange: string
          acceptProp: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderMediaFieldChangeHandlerTemplate':
      return renderMediaFieldChangeHandlerTemplate(request.props)
    case 'renderMediaFieldFormFieldTemplate':
      return renderMediaFieldFormFieldTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
